import React from 'react';

import { Typography } from '@mui/material';

import { useI18n } from '@braincube/i18n';

import { MainSection, MainSectionTitle, MainSectionContent } from 'components/MainSection';

function Confirm() {
    const i18n = useI18n();

    return (
        <MainSection>
            <MainSectionTitle>{i18n.t('app.emailSent')}</MainSectionTitle>
            <MainSectionContent>
                <Typography variant="body2">{i18n.tc('account.confirm.text')}</Typography>
            </MainSectionContent>
        </MainSection>
    );
}

export default Confirm;
